import React from 'react'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { type FigureInfoGroupFilter } from '~/utils'

import styles from './FigureInfoGroupFilters.css'

export type FigureInfoGroupFiltersProps = {
  groupFilters: FigureInfoGroupFilter[]
}

export const FigureInfoGroupFilters = ({
  groupFilters,
}: FigureInfoGroupFiltersProps) => (
  <VStack spacing={1}>
    {groupFilters.map(({ brands, name }) => (
      <VStack key={name} spacing={1}>
        <Typography variant="normal">{name}</Typography>

        <VStack className={styles.indent} spacing={1}>
          {brands.map(({ name: brandName, segments }) => (
            <VStack key={brandName} className={styles.indent} spacing={1}>
              <Typography variant="normal">{brandName}</Typography>

              <VStack className={styles.indent} spacing={1}>
                <Typography variant="normal">{segments.join(', ')}</Typography>
              </VStack>
            </VStack>
          ))}
        </VStack>
      </VStack>
    ))}
  </VStack>
)
